import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addNewPilotChargeData,
  deletePilotCharge,
  fetchPilotCharges,
  updatePilotCharge,
} from "../thunks/pilotChargeThunks";

import type { PilotCharge } from "../../utils/types/pilotCharge";

interface PilotChargeListState {
  pilotChargeList: PilotCharge[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: PilotChargeListState = {
  pilotChargeList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const PilotChargeListSlice = createSlice({
  name: "pilotCharges",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPilotCharges.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
      })
      .addCase(fetchPilotCharges.fulfilled, (state, action) => {
        state.pilotChargeList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchPilotCharges.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });

    builder
      .addCase(updatePilotCharge.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePilotCharge.fulfilled, (state, action) => {
        state.loading = false;
        state.pilotChargeList = state.pilotChargeList.map((charge) => {
          if (charge.pilotChargeId === action.payload?.pilotChargeId) {
            return { ...charge, ...action.payload };
          }
          return charge;
        });
      })
      .addCase(updatePilotCharge.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deletePilotCharge.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePilotCharge.fulfilled, (state, action) => {
        state.loading = false;
        state.pilotChargeList = state.pilotChargeList.filter(
          (charge) => charge.pilotChargeId !== action.payload?.id
        );
      })
      .addCase(deletePilotCharge.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewPilotChargeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewPilotChargeData.fulfilled, (state, action) => {
        state.loading = false;
        state.pilotChargeList = [action.payload, ...state.pilotChargeList];
      })
      .addCase(addNewPilotChargeData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
      addWebSocketCases(builder, "pilotCharge", "pilotChargeList");
  },
});

export const { resetDataFetched } = PilotChargeListSlice.actions;
export default PilotChargeListSlice.reducer;
